
import styled from 'styled-components';
import { spaceMixin } from '@zillow/constellation';

export const StyledTopBanner = styled.div`
    padding: ${spaceMixin('md')} ${spaceMixin('xs')};
    border-top: 1px solid #d8d8d8;
`;
